import React from 'react';
import Layout from '../components/layout/Layout';
import Hero from '../components/home/Hero';
import FeaturedProject from '../components/home/FeaturedProject';
import AboutPreview from '../components/home/AboutPreview';
// import Testimonials from '../components/home/Testimonials';
import CallToAction from '../components/home/CallToAction';
import Services from '../components/home/Services';

const Home = () => {

  const featuredProject = {
    title: 'The Nest Eco-Housing Project',
    description: 'Sustainable luxury living in harmony with nature. The Nest is our signature eco-housing project that combines modern architecture with environmental consciousness.',
    image: '/assets/images/project-images/nest-project/exterior.jpg',
    link: '/projects/nest'
  };

  // const testimonials = [
  //   {
  //     text: "Vasudharini transformed our vision into a stunning reality. Their commitment to sustainable design without compromising on aesthetics is remarkable.",
  //     author: "Rajiv Mehta",
  //     company: "GreenTech Industries"
  //   },
  //   {
  //     text: "Working with the Vasudharini team was a pleasure from concept to completion. Their attention to detail and innovative approach to sustainability sets them apart.",
  //     author: "Priya Sharma",
  //     company: "EcoLife Homes"
  //   }
  // ];

  return (
    <Layout>
      <Hero
        title="Designing Sustainable Spaces for a Better Tomorrow"
        subtitle="Vasudharini is an award-winning architectural firm specializing in eco-friendly design solutions that blend innovation, functionality, and harmony with nature."
        ctaText="View Our Projects"
        ctaLink="/projects"
      />
      <AboutPreview />
      <FeaturedProject project={featuredProject} />
      <Services />
      {/* <Testimonials testimonials={testimonials} /> */}
      <CallToAction
        title="Ready to Start Your Sustainable Building Journey?"
        subtitle="Let's discuss how we can bring your vision to life with sustainability at its core."
        ctaText="Contact Us"
        ctaLink="/contact"
      />
    </Layout>
  );
};

export default Home;